import { writable } from "svelte/store";

const { subscribe, set } = writable(null);

function init(width: number) {
  set(width);
}

export const mattressWidth = {
  subscribe,
  init,
};
